import { render, staticRenderFns } from "./CardHeadInfoItem.vue?vue&type=template&id=3fbbe292&scoped=true&"
import script from "./CardHeadInfoItem.vue?vue&type=script&lang=js&"
export * from "./CardHeadInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbbe292",
  null
  
)

export default component.exports